import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { _MSGTYPES } from '../../../constant/msgType';
import { formatNumber } from '../../../utils/common';
import echarts from 'echarts';

@Component({
  selector: 'icc-radio-sms-channel',
  templateUrl: './icc-radio-sms-channel.component.html',
  styleUrls: ['./icc-radio-sms-channel.component.less'],
})
export class IccRadioSmsChannelComponent implements OnInit, OnDestroy {
  constructor() {}

  // 图谱实例
  chartIns: any;
  colorList = ['#58d3ff', '#34a2ff', '#23d3a0', '#91ef7a', '#fbbb15', '#fb7649', '#e9ef00', '#7e85e6'];
  pieData: Array<{
    name: string; // 渠道名称
    value: number; // 发送量
    valueStr: string; // 千分符格式化发送量
    radio: number; // 发送占比
    success: number;
  }>;
  // 数据源
  @Input() data: Array<{
    channelName: number; // 渠道名称
    count: number; // 发送量
    radio: number; // 发送占比
    success: number; // 成功率
  }>;
  // 自适应函数
  resizeCharts = () => {
    if (this.chartIns) {
      this.chartIns.resize();
    }
  };
  ngOnInit() {
    if (this.data instanceof Array && this.data.length) {
      setTimeout(() => {
        this.pieData = this.formatPieData();
        this.createLineChart('icc-radio-sms-channel-chart-id');
      }, 0);
    }
    window.addEventListener('resize', this.resizeCharts);
  }
  ngOnDestroy() {
    if (this.chartIns) {
      this.chartIns.dispose();
      this.chartIns = null;
    }
    window.removeEventListener('resize', this.resizeCharts);
  }
  formatPieData() {
    const result = [];
    this.data.forEach((item: any, index: number) => {
      if (index < 5) {
        const temp: any = {};
        temp.name = item.channelName;
        temp.value = item.count;
        temp.valueStr = formatNumber(item.count);
        temp.radio = item.ratio;
        temp.success = item.success;
        result.push(temp);
      }
    });
    return result;
  }
  /* 生成图谱 */
  createLineChart(domId) {
    if (!this.chartIns) {
      this.chartIns = echarts.init(document.getElementById(domId));
    }
    this.chartIns.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{b} : {c}',
      },
      legend: {
        show: false,
      },
      series: [
        {
          type: 'pie',
          color: this.colorList,
          radius: [0, '75%'],
          center: '50%',
          roseType: false,
          label: {
            position: 'inside',
            formatter: '{d}%',
          },
          data: this.pieData,
        },
      ],
    });
  }
}
